import { DashboardWidget } from 'features/widget/types'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { ServiceResultEntry } from 'schemas/ServiceResultEntrySchema'
import { TopicInfo } from 'schemas/TopicInfoSchema'
import MetricSeries from 'enums/MetricSeries'
import { isDatasetLanguageNotSupported } from '../../utils/languageNotSupportedChecker'
import { isEmptyDataset } from '../../utils/dataNotReturnedChecker'
import resolveMaxMentionsValue from './maxMentionsValueResolver'
import resolveServiceResultEntryMap from './serviceResultEntryMapResolver'
import resolveMetricSeriesValue from './metricSeriesValueResolver'
import {
  INSUFFICIENT_BOUND,
  DEFAULT_CHART_HEIGHT_IN_PX,
  DIAMETER_MAX_PERCENT,
  MIN_DIAMETER_IN_PX
} from './constants'

const resolveBubbleSeries = (
  serviceResultEntries: ServiceResultEntry[],
  maxMentionsValue: number
) => {
  const bubbleDiameterMaxPxAllowed = DEFAULT_CHART_HEIGHT_IN_PX * DIAMETER_MAX_PERCENT
  const denominator = Math.max(maxMentionsValue, 100)

  return serviceResultEntries.map((serviceResultEntry) => {
    const metricResult: AnnotatedMetricResult = serviceResultEntry.data
    const { startDate, endDate } = metricResult
    const dataset = metricResult!.metrics![0].dataset!

    const mentionsValue = resolveMetricSeriesValue(dataset, MetricSeries.TOTAL_BUZZ)
    const netSentimentValue = resolveMetricSeriesValue(dataset, MetricSeries.NET_SENTIMENT)
    const passionValue = resolveMetricSeriesValue(dataset, MetricSeries.PASSION)
    const languageSupported = !isDatasetLanguageNotSupported(dataset)
    const noData = !languageSupported || mentionsValue === 0 || isEmptyDataset(dataset)
    const shouldBeRendered = languageSupported && !noData && mentionsValue >= INSUFFICIENT_BOUND

    let diameter = bubbleDiameterMaxPxAllowed * Math.sqrt(mentionsValue / denominator)
    diameter = diameter > MIN_DIAMETER_IN_PX ? diameter : MIN_DIAMETER_IN_PX
    const radius = shouldBeRendered ? diameter / 2 : 0

    return {
      startDate: startDate!,
      endDate: endDate!,
      size: mentionsValue,
      x: netSentimentValue,
      y: passionValue,
      radius,
      supported: languageSupported,
      noData
    }
  })
}

const resolveBubbleData = (
  searchResult: DashboardWidget<AnnotatedMetricResult>,
  topicInfos: TopicInfo[]
) => {
  const maxMentionsValue = resolveMaxMentionsValue(searchResult)
  const serviceResultEntryMap = resolveServiceResultEntryMap(searchResult)

  return Array.from(serviceResultEntryMap).map(([topicId, ServiceResultEntries]) => {
    const { name, imgUrl } = topicInfos.find((topicInfo) => topicInfo.topicId === topicId)!
    const bubbleSeries = resolveBubbleSeries(ServiceResultEntries, maxMentionsValue!)

    return {
      id: topicId,
      name: name!,
      image: imgUrl!,
      series: bubbleSeries
    }
  })
}

export default resolveBubbleData
